import '../../js/vendor/polyfills/polyfill-array-from.js';
import '../../js/vendor/polyfills/polyfill-classlist.js';

/**
 * Category filter
 */
export function deltaFilters() {
	const element = document.querySelector('[data-category-filter]');
	if (!element) {
		return;
	}
	const items = Array.from(document.querySelectorAll('[data-categories]'));
	const itemCountContainer = document.querySelector(
		'[data-category-filter-count]'
	);
	const filterControls = Array.from(element.querySelectorAll('select'));

	// Reset the filter
	window.addEventListener('pageshow', () => {
		filterControls.forEach((control) => {
			control.value = '';
		});
		items.forEach((item) => {
			item.style.display = 'flex';
		});
		_setItemCount(items.length);
	});

	let filters = [];

	items.forEach((item) => {
		try {
			filters.push(JSON.parse(item.dataset.categories));
		}
		catch (e) {
			console.warn('No categories found for item:', item);
		}
	});
	const itemDefaultDisplayValue = items[0].style.display;
	let activeFilters = _setupActiveFilters();

	filterControls.forEach((control) => {
		_addEvent(control);
	});

	function _setupActiveFilters() {
		let obj = {};
		filterControls.forEach((control) => {
			obj[control.name] = '';
		});

		return obj;
	}

	function _addEvent(control) {
		control.addEventListener('change', () => {
			const filterType = control.name;
			const selectedFilter = control.options[control.selectedIndex].value;

			selectedFilter
				? (activeFilters[filterType] = selectedFilter)
				: (activeFilters[filterType] = '');

			const count = _filterContent();
			_setItemCount(count);
		});
	}

	function _filterContent() {
		let count = 0;

		items.forEach((item) => {
			item.style.display = 'none';

			let itemMatch = [];
			Object.keys(activeFilters).forEach((key) => {
				if (activeFilters[key] !== '') {
					itemMatch.push(_matchFilter(item, key, activeFilters[key]));
				}
				else {
					itemMatch.push(true);
				}
			});

			if (itemMatch.every((i) => i === true)) {
				item.style.display = itemDefaultDisplayValue;
				count++;
			}
		});

		return count;
	}

	function _matchFilter(item, key, activeFilter) {
		try {
			let itemFilters = JSON.parse(item.dataset.categories);

			if (itemFilters[key].includes(activeFilter)) {
				return true;
			}
		}
		catch (e) {
			return false;
		}

		return false;
	}

	function _setItemCount(count) {
		itemCountContainer.innerText = count;
	}
}

export function deltaSort() {
	const sort = document.querySelector('[data-sort]');
	if (!sort) {
		return;
	}

	const sortSelect = sort.querySelector('select');
	sortSelect.addEventListener('change', () => {
		sortItems();
	});
}

function sortItems() {
	const sortSelect = document.querySelector('#sort');
	const items = Array.from(document.querySelectorAll('[data-categories]'));
	const itemContainer = items[0].parentNode;
	const sortOrder = sortSelect.options[sortSelect.selectedIndex].value;

	let sortedItems = [];
	switch (sortOrder) {
		case 'published':
			sortedItems = items.sort((a, b) => {
				const aNum = parseInt(a.dataset.published);
				const bNum = parseInt(b.dataset.published);
				return bNum - aNum;
			});
			break;
		case 'published-reverse':
			sortedItems = items.sort((a, b) => {
				const aNum = parseInt(a.dataset.published);
				const bNum = parseInt(b.dataset.published);
				return bNum - aNum;
			}).reverse();
			break;
		case 'title':
			sortedItems = items.sort((a, b) => {
				return a.dataset.title.localeCompare(b.dataset.title);
			});
			break;
		case 'recommended':
			sortedItems = items.sort((a, b) => {
				const aNum = parseInt(a.dataset.recommended);
				const bNum = parseInt(b.dataset.recommended);
				return aNum - bNum;
			});
			break;
	}

	items.forEach((item) => {
		itemContainer.removeChild(item);
	});

	sortedItems.forEach((item) => {
		itemContainer.appendChild(item);
	});
}



// WEBPACK FOOTER //
// ./pages/delta/delta.js